import { Course } from "@jelly/lesson";
import course01 from "./course-01/course";
import course02 from "./course-02/course";
import course03 from "./course-03/course";
import course04 from "./course-04/course";
import course05 from "./course-05/course";

/* eslint-disable max-len */
const data: Course[] = [
  {
    id: course01.id,
    publicId: course01.publicId,
    slug: course01.slug,
    name: course01.name,
    description: course01.description,
    shortDescription: course01.shortDescription,
  },
  {
    id: course02.id,
    publicId: course02.publicId,
    slug: course02.slug,
    name: course02.name,
    description: course02.description,
    shortDescription: course02.shortDescription,
  },
  {
    id: course03.id,
    publicId: course03.publicId,
    slug: course03.slug,
    name: course03.name,
    description: course03.description,
    shortDescription: course03.shortDescription,
  },
  {
    id: course04.id,
    publicId: course04.publicId,
    slug: course04.slug,
    name: course04.name,
    description: course04.description,
    shortDescription: course04.shortDescription,
  },
  {
    id: course05.id,
    publicId: course05.publicId,
    slug: course05.slug,
    name: course05.name,
    description: course05.description,
    shortDescription: course05.shortDescription,
  },
];
/* eslint-enable max-len */

export default data;
